// @ts-check
import React, { useCallback, useState } from 'react';
import PropertiesConditionEditor from './PropertiesConditionEditor';
import { Modal, ModalVariant } from '@patternfly/react-core';
import { confirmButtons } from 'components/Modals/ModalButtons';
import { useTranslation } from 'localization/useTranslation';

/**
 * @typedef {object} PropertiesConditionEditorModalProps
 * @property {import('./PropertiesConditionEditor').Condition[]} conditions
 * @property {string} [title]
 * @property {boolean} isOpen
 * @property {(newConditions: import('./PropertiesConditionEditor').Condition[]) => void} onConfirm
 * @property {() => void} onCancel
 */

/**
 *
 * @param {PropertiesConditionEditorModalProps} props
 * @returns {JSX.Element}
 */
const PropertiesConditionEditorModal = ({ title, conditions, isOpen, onConfirm, onCancel }) => {
  const T = useTranslation();
  const [changedConditions, setChangedConditions] = useState(conditions);
  const _onConfirm = useCallback(() => {
    onConfirm(changedConditions);
  }, [changedConditions, onConfirm]);

  const _onCancel = useCallback(() => {
    setChangedConditions(conditions);
    onCancel();
  }, [conditions, onCancel]);

  return (
    // @ts-ignore-next-line
    <Modal
      variant={ModalVariant.large}
      title={T.localize(title) ?? T.common.propertiesconditions}
      isOpen={isOpen}
      onClose={_onCancel}
      appendTo={() => document.body}
      footer={confirmButtons({
        T,
        onConfirm: _onConfirm,
        onCancel: _onCancel
      })}
    >
      <PropertiesConditionEditor conditions={changedConditions} onConditionsChanged={setChangedConditions}/>
    </Modal>
  );
};
export default PropertiesConditionEditorModal;
